const usingServiceAdvantage = {
  en: {
    title: 'Enhance the Guest Experience with Tech',
    desc: 'Increase order speed, accuracy, and efficiency',
    items: [
      {
        title: 'Putting the Customer Experience First',
        image: `${process.env.ASSETS_PREFIX}/businesstype/salmon-roll-and-chopsticks.jpg`,
        items: [
          {
            desc: 'Easy digital menu management with a click of a button',
          },
          {
            desc: 'Never miss an order or customization on the menu',
          },
          {
            desc: 'Save off tons of time with table-side POS systems',
          },
          {
            desc: 'Save big on labor, while upgrading the customer experience!',
          },
        ],
      },
      {
        title: 'Better Service, Better Profits ',
        image: `${process.env.ASSETS_PREFIX}/businesstype/korean_bbq-service-type_usage_04.jpeg`,
        items: [
          {
            desc: 'Increase table turnover by 20% with handheld and self-order POS systems',
          },
          {
            desc: 'Allow guests to join waitlists and book reservations in advance!',
          },
          {
            desc: 'Use our loyalty, CRM, and gift card programs to turn one-time customers into your regulars!',
          },
        ],
      },
      {
        title: 'Better Service, Better Profits',
        image: `${process.env.ASSETS_PREFIX}/businesstype/korean_bbq-service-type_usage_03.jpeg`,
        items: [
          {
            desc: 'Our POS system saves the average restaurant up to $8,000/month in labor costs',
          },
          {
            desc: 'POS customers also see 15% increases in average order size',
          },
          {
            desc: 'Remove redundant costly tasks, which can boost sales volume, tips, staff productivity, and your bottom line!',
          },
        ],
      },
    ],
  },
  zh: {
    title: '提升顾客用餐体验',
    desc: '使用Chowbus POS可以显著提升出餐速度、准确性和运营效率',
    items: [
      {
        title: '升级顾客体验',
        image: `${process.env.ASSETS_PREFIX}/businesstype/salmon-roll-and-chopsticks.jpg`,
        items: [
          {
            desc: '有双语电子菜单供顾客选择，顾客可以通过图片和描述更好地了解菜品',
          },
          {
            desc: '顾客可以通过扫码/平板点单，实现从下单到支付的全自助服务',
          },
          {
            desc: '使用手持POS进行桌边支付，大大缩短顾客结账时间，提升顾客结账体验',
          },
        ],
      },
      {
        title: '减少等待时间 ',
        image: `${process.env.ASSETS_PREFIX}/businesstype/korean_bbq-service-type_usage_04.jpeg`,
        items: [
          {
            desc: '线上取号了解排队时间，短信提醒到店用餐，减少顾客等位时间',
          },
          {
            desc: '顾客可以使用二维码、平板、网页等自助下单，减少等待点餐的时间',
          },
          {
            desc: '顾客一键下单，订单直达后厨，减少顾客等待餐品的时间',
          },
        ],
      },
      {
        title: '提升餐厅利润',
        image: `${process.env.ASSETS_PREFIX}/businesstype/hotpot-service-type_usage_03.jpeg`,
        items: [
          {
            desc: 'Chowbus POS帮助您在点单、结账、订单管理等环节显著减少人力成本',
          },
          {
            desc: '关注顾客复购率，善用会员、积分、礼品卡、营销短信等方式发展您的回头客，提升营业额',
          },
          {
            desc: '更快的服务、更优的顾客体验有效提升顾客的复购率及营业额',
          },
        ],
      },
    ],
  },
};

export default usingServiceAdvantage;
